import { GetDataValid } from "./../models/getDataValid.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class GetDataValidService {
    constructor(private http: HttpClient) {}

    getParticipanteData(cpf: string): Observable<Partial<GetDataValid>> {
        return this.http
            .get<GetDataValid>(
                `${environment.TrustCRMApiHost}api/DataValid/GetDataValid?nrCpf=${cpf}`
            )
            .pipe(
                map((data: GetDataValid) => ({
                    cpf_disponivel: data.cpf_disponivel,
                    nome_similaridade: data.nome_similaridade,
                    data_nascimento: data.data_nascimento,
                    situacao_cpf: data.situacao_cpf,
                    totalAprovacao: data.totalAprovacao,
                    situacao: data.situacao,
                }))
            );
    }
}
